import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 5.255a.75.75 0 0 1 .75.75v5.25h3.75a.75.75 0 0 1 0 1.5H12a.75.75 0 0 1-.75-.75v-6a.75.75 0 0 1 .75-.75"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M2.25 12.005c0-5.385 4.365-9.75 9.75-9.75s9.75 4.365 9.75 9.75-4.365 9.75-9.75 9.75-9.75-4.366-9.75-9.75M12 3.755a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }